var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leo2-ok-header"},[(_vm.isMask)?_c('div',{staticClass:"ok-mask"}):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-inner"},[_c('a',{staticClass:"ui-navbar-logo",attrs:{"href":"/","title":"玩得赚官网"}},[_c('img',{attrs:{"src":require("../assets/images/logo.png?v=3")}})]),_c('div',{staticClass:"menu-block"})])
}]

export { render, staticRenderFns }